import { Component, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'hb-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  hideSub: Subscription;

  title = this.i18NextPipe.transform('ConfirmationDialog.Title');
  messageTop: string;
  messageBottom: string;
  showCancel: boolean = true;
  showPrimaryAlert: boolean = false;
  alertMessage: string;

  affirmativeActionLabel = this.i18NextPipe.transform('ConfirmationDialog.Ok');
  negativeActionLabel = this.i18NextPipe.transform('ConfirmationDialog.Cancel');

  public afterClosed = new Subject<boolean>();

  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService, private i18NextPipe: I18NextPipe) { }

  ngOnInit() {
    this.hideSub = this.modalService.onHide.subscribe(() => this.submit(false));
  }

  submit(result: boolean) {
    this.afterClosed.next(result);
    this.hideSub.unsubscribe();
    this.bsModalRef.hide();
  }
}
